<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dgpjWE/tc-custom/9781618685728.jpg?1706124872137" alt="This image is the cover for the book Journal: Crimson Skies, The Journal Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Journal: Crimson Skies, The Journal Series
      </h1>
      <p class="bookDescription body article font2">
        <b>The post-apocalyptic saga takes you headlong into the fury that only Mother Nature can dish out—and that only those who have prepared for can survive.</b><br/><br/>Massive electrical storms roll across the upper peninsula of Michigan as a result of the supervolcano eruption. Destructive lightning sets the city on fire, illuminating the night with blood-red skies. Allexa Smeth and her town of Moose Creek are finding it more and more difficult to survive the latest unleashing of natural—and manmade—disasters. The land is becoming more uninhabitable, and those who choose to stay might end up digging their own graves. <br/><br/><b>“Learning from survival fiction is one of my passions although I do recognize and accept that many of the scenarios are quite extreme. Still, as a prepper that is continually challenged by the pursuit of knowledge, I keep reading and keep playing the ‘what if’ game in my own mind. One of the best series of books for doing so is Deborah D. Moore’s The Journal series.” —<i>Backdoor Survival</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah D. Moore
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a7c6e17c